module.exports = __webpack_public_path__ + "static/media/right-slider-arrow.1ea0269b.svg";